import React from "react";

export default function Instruction() {
  return (
    <>
      <style>{`
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
          scroll-behavior: smooth;
        }

        body {
          font-family: Arial, Helvetica, sans-serif;
          background: #f4f7fb;
          color: #222;
          line-height: 1.8;
        }

        .hero {
          width: 100%;
          min-height: 420px;
          background:
            linear-gradient(rgba(0,0,0,0.35), rgba(0,0,0,0.55)),
            url("/images/assets/w1.png");
          background-size: cover;
          background-position: center;
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;
          padding: 40px 20px;
          position: relative;
          overflow: hidden;
        }

        .hero::after {
          content: "";
          position: absolute;
          inset: 0;
          background: linear-gradient(
            to bottom,
            rgba(0,0,0,0.2),
            rgba(0,0,0,0.65)
          );
        }

        .hero-content {
          max-width: 900px;
          color: white;
          position: relative;
          z-index: 2;
        }

        .hero h1 {
          font-size: 3.5rem;
          margin-bottom: 20px;
          font-weight: 800;
          line-height: 1.2;
        }

        .hero p {
          font-size: 1.2rem;
          opacity: 0.95;
        }

        .container {
          width: 92%;
          max-width: 1200px;
          margin: auto;
          padding: 70px 0;
        }

        .intro {
          background: white;
          padding: 38px;
          border-radius: 28px;
          box-shadow: 0 10px 30px rgba(0,0,0,0.08);
          margin-bottom: 35px;
          margin-top: -40px
        }

        .intro p {
          font-size: 1.08rem;
          color: #444;
        }

        .toc {
          background: linear-gradient(135deg, #ffffff, #eef5ff);
          padding: 38px;
          border-radius: 28px;
          margin-bottom: 70px;
          box-shadow: 0 10px 25px rgba(0,0,0,0.06);
            position: relative !important;
  top: auto !important;
        }

        .toc h2 {
          margin-bottom: 25px;
          font-size: 2rem;
          color: #1d4ed8;
        }

        .toc ul {
          list-style: none;
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
          gap: 18px;
        }

        .toc a {
          display: block;
          text-decoration: none;
          background: white;
          padding: 18px 22px;
          border-radius: 16px;
          color: #222;
          font-weight: 600;
          transition: 0.3s ease;
          border: 2px solid transparent;
          line-height: 1.5;
          box-shadow: 0 4px 12px rgba(0,0,0,0.04);
        }

        .toc a:hover {
          transform: translateY(-4px);
          border-color: #3b82f6;
          box-shadow: 0 10px 25px rgba(59,130,246,0.18);
        }

        .section {
          background: white;
          border-radius: 30px;
          overflow: hidden;
          margin-bottom: 70px;
          box-shadow: 0 12px 35px rgba(0,0,0,0.08);
          transition: 0.35s ease;
        }

        .section:hover {
          transform: translateY(-6px);
          box-shadow: 0 18px 40px rgba(0,0,0,0.12);
        }

        .section img {
          width: 90%;
          max-width: 950px;
          height: auto;
          display: block;
          margin: 35px auto 0;
          border-radius: 24px;
          box-shadow: 0 10px 30px rgba(0,0,0,0.12);
        }

        .section-content {
          padding: 45px;
        }

        .section h2 {
          font-size: 2.3rem;
          margin-bottom: 22px;
          color: #111827;
          line-height: 1.2;
        }

        .section p {
          margin-bottom: 22px;
          font-size: 1.06rem;
          color: #444;
        }

        .section ol,
        .section ul {
          padding-left: 25px;
          margin-top: 15px;
        }

        .section li {
          margin-bottom: 18px;
          color: #444;
        }

        .tips-box {
          background: linear-gradient(135deg, #2563eb, #60a5fa);
          color: white;
          padding: 50px 35px;
          border-radius: 30px;
          text-align: center;
          box-shadow: 0 12px 30px rgba(37,99,235,0.3);
          margin-top: 20px;
        }

        .tips-box h2 {
          font-size: 2.5rem;
          margin-bottom: 20px;
        }

        .tips-box p {
          font-size: 1.1rem;
          max-width: 850px;
          margin: auto;
          opacity: 0.96;
        }

        .top-btn-wrapper {
          text-align: center;
          margin-top: 55px;
        }

        .top-btn {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          background: #111827;
          color: white;
          text-decoration: none;
          padding: 16px 32px;
          border-radius: 999px;
          font-size: 1rem;
          font-weight: bold;
          transition: 0.3s ease;
          box-shadow: 0 8px 20px rgba(0,0,0,0.15);
        }

        .top-btn:hover {
          transform: translateY(-4px);
          background: #2563eb;
        }

        footer {
          text-align: center;
          padding: 45px 20px;
          color: #666;
          font-size: 0.95rem;
        }

        @media (max-width: 900px) {
          .hero h1 {
            font-size: 2.5rem;
          }

          .hero p {
            font-size: 1rem;
          }

          .section-content {
            padding: 30px;
          }

          .section h2 {
            font-size: 1.9rem;
          }

          .tips-box h2 {
            font-size: 2rem;
          }
        }

        @media (max-width: 600px) {
          .hero {
            min-height: 320px;
          }

          .hero h1 {
            font-size: 2rem;
          }

          .container {
            width: 94%;
          }

          .intro,
          .toc,
          .section-content,
          .tips-box {
            padding: 24px;
          }

          .toc ul {
            grid-template-columns: 1fr;
          }

          .section h2 {
            font-size: 1.6rem;
          }

          .tips-box h2 {
            font-size: 1.7rem;
          }

          .section img {
            width: 94%;
          }
        }
      `}</style>

      <div id="top">
        <section className="hero">
          <div className="hero-content">
            <h1>How To Properly Care For Graphic Tees</h1>

            <p>
              Learn the best washing, drying, and maintenance techniques
              to keep your graphic tees looking bright, soft, vibrant,
              and long-lasting for years to come.
            </p>
          </div>
        </section>

        <div className="container">
          <div className="intro">
            <p>
              Graphic tees featuring custom artwork, logos, and unique printed
              designs are more than just casual clothing — they are often a
              reflection of personality, style, hobbies, and creativity.
            </p>
          </div>

          <div className="toc">
            <h2>Table Of Contents</h2>

            <ul>
              <li>
                <a href="#machine-washing">
                  Machine Washing Graphic Tees
                </a>
              </li>

              <li>
                <a href="#hand-washing">
                  Hand Washing Graphic Tees
                </a>
              </li>

              <li>
                <a href="#drying">
                  Drying Graphic Tees
                </a>
              </li>

              <li>
                <a href="#wrinkles">
                  Removing Wrinkles
                </a>
              </li>

              <li>
                <a href="#preserve">
                  Preserve Your Prints
                </a>
              </li>
            </ul>
          </div>

 <section class="section" id="machine-washing">
      <img src="/images/assets/w1.png" alt="Machine washing graphic tees"/>

      <div class="section-content">
        <h2>Machine Washing Graphic Tees</h2>

        <p>
          Graphic tees are more than everyday clothing — they often feature
          custom artwork, favorite brands, meaningful prints, or limited-edition
          designs that deserve extra care during the washing process. Improper
          washing techniques can quickly lead to cracked graphics, faded colors,
          damaged fabric, and shrinking. By following a gentle washing routine,
          you can significantly extend the lifespan of your shirts while keeping
          them looking soft, clean, and vibrant after every wash.
        </p>

        <ol>
          <li>
            Before placing your shirt in the washing machine, carefully inspect
            it for stains or heavily soiled areas. Apply a gentle stain remover
            or a natural cleaning solution such as diluted white vinegar to the
            affected spots. Avoid harsh scrubbing directly on printed graphics,
            as friction can weaken and damage the design.
          </li>

          <li>
            Choose a mild detergent that does not contain bleach, aggressive
            chemicals, or strong fabric softeners. Harsh detergents can weaken
            fabric fibers and cause printed artwork to fade or peel over time.
          </li>

          <li>
            Turn graphic tees inside out before washing. This simple step helps
            protect the printed design from rubbing against zippers, buttons,
            rough fabrics, and other clothing during the wash cycle.
          </li>

          <li>
            Wash your shirts in cold water using a gentle or delicate cycle.
            Cold water is much safer for printed garments and helps preserve
            both the fabric quality and the brightness of the design.
          </li>
        </ol>
      </div>
    </section>

    <section class="section" id="hand-washing">
      <img src="/images/assets/w2.png" alt="Hand washing graphic tees"/>

      <div class="section-content">
        <h2>Hand Washing Graphic Tees</h2>

        <p>
          If you want to provide maximum protection for your favorite graphic
          apparel, hand washing is one of the safest and most effective cleaning
          methods available. Unlike machine washing, hand washing minimizes
          friction and agitation, helping preserve delicate prints, specialty
          inks, embroidery, and softer fabrics. This method is especially ideal
          for premium, vintage, or sentimental graphic tees.
        </p>

        <ol>
          <li>
            Fill a clean sink, tub, or basin with cold water and add a small
            amount of gentle detergent designed for delicate fabrics or
            sensitive materials.
          </li>

          <li>
            Turn the shirt inside out before placing it into the water to help
            protect the graphic design from unnecessary rubbing and friction.
          </li>

          <li>
            Apply stain remover carefully to areas that require additional
            cleaning attention. Allow the solution to sit briefly to loosen
            dirt and oils without damaging the fabric.
          </li>

          <li>
            Gently rub the fabric together using your hands or a soft cloth.
            Avoid twisting, stretching, or aggressively scrubbing the shirt.
          </li>

          <li>
            Allow the garment to soak for approximately 10 to 15 minutes so the
            detergent can thoroughly clean the fibers.
          </li>

          <li>
            Rinse completely with clean cold water until all soap residue has
            been removed. Carefully squeeze out excess water without wringing
            the shirt too aggressively.
          </li>
        </ol>
      </div>
    </section>

    <section class="section" id="drying">
      <img src="/images/assets/w3.png" alt="Drying graphic tees"/>

      <div class="section-content">
        <h2>Drying Graphic Tees</h2>

        <p>
          Proper drying techniques are just as important as proper washing.
          Excessive heat exposure can crack graphics, fade colors, shrink
          fabric, and reduce the lifespan of printed apparel. Taking a few
          extra precautions during the drying process will help preserve both
          the artwork and overall quality of your shirts.
        </p>

        <ul>
          <li>
            <strong>Air Drying:</strong>
            Air drying is widely considered the best option for graphic tees.
            Hang your shirt on a plastic hanger or lay it flat on a clean
            surface in a well-ventilated area. This method minimizes heat
            damage, reduces shrinking, and helps preserve printed graphics.
          </li>

          <li>
            <strong>Machine Drying:</strong>
            If using a dryer, always select the lowest possible heat setting
            and keep the shirt turned inside out. Remove the garment while it
            is still slightly damp to reduce prolonged heat exposure and help
            prevent wrinkles from setting into the fabric.
          </li>
        </ul>
      </div>
    </section>

    <section class="section" id="wrinkles">
      <img src="/images/assets/w4.png" alt="Removing wrinkles"/>

      <div class="section-content">
        <h2>Removing Wrinkles</h2>

        <p>
          After washing and drying your graphic tees, you may notice wrinkles
          or creases in the fabric. While ironing and steaming can restore a
          clean and polished appearance, it is important to avoid direct heat
          contact with printed graphics to prevent damage.
        </p>

        <ul>
          <li>
            <strong>Ironing:</strong>
            Turn the shirt inside out before ironing and select the lowest heat
            setting suitable for the fabric type. Place a thin cloth or towel
            between the iron and the shirt for additional protection. Never
            apply direct heat onto printed artwork.
          </li>

          <li>
            <strong>Steaming:</strong>
            Steaming is often a gentler alternative to ironing. Hang the shirt
            inside out and carefully steam around the printed areas rather than
            directly over them to safely release wrinkles.
          </li>
        </ul>
      </div>
    </section>

    <section class="section" id="preserve">
      <img src="/images/assets/w5.png" alt="Preserve your prints"/>

      <div class="section-content">
        <h2>Preserve Your Prints With Proper Care</h2>

        <p>
          With the right care routine, your graphic tees can continue looking
          bright, comfortable, stylish, and vibrant for many years. Gentle
          washing, low-heat drying, proper storage, and careful wrinkle removal
          all contribute to maintaining both the fabric quality and the printed
          artwork.
        </p>

        <p>
          Taking a little extra time to properly care for your shirts can make
          a significant difference in their long-term appearance. Whether your
          tees feature custom artwork, vintage graphics, or everyday casual
          designs, treating them with care helps preserve their personality and
          keeps them looking as fresh as the day you bought them.
        </p>
      </div>
    </section>

    <div class="tips-box">
      <h2>Keep Your Graphic Tees Looking Fresh</h2>

      <p>
        Wash with cold water, avoid harsh chemicals, use gentle detergents,
        dry on low heat, and always protect printed designs during cleaning.
        Following these simple habits will help your favorite graphic tees stay
        soft, colorful, comfortable, and long-lasting.
      </p>
    </div>


          {/* <div className="tips-box">
            <h2>Keep Your Graphic Tees Looking Fresh</h2>

            <p>
              Wash with cold water, avoid harsh chemicals, use gentle
              detergents, and protect printed designs during cleaning.
            </p>
          </div> */}

          <div className="top-btn-wrapper">
            <a href="#top" className="top-btn">
              ↑ Go To Top
            </a>
          </div>
        </div>

        {/* <footer>
          © 2026 Graphic Tee Care Guide • Modern Responsive Article Design
        </footer> */}
      </div>
    </>
  );
}